import ncFlag from "../assets/flags/nc.svg";

// flagcdn only carries real ISO 3166-1 alpha-2 codes. Countries stored with a
// non-ISO code (e.g. Northern Cyprus = "NY") have no flagcdn entry, so we map
// them to a bundled asset here. Keyed by the uppercased country code.
const FLAG_OVERRIDES = {
  NY: ncFlag,
};

// Resolve a flag image URL from a 2-letter country code, or null if none.
export function flagSrcForCode(code) {
  const raw = String(code || "").trim();
  const override = FLAG_OVERRIDES[raw.toUpperCase()];
  if (override) return override;
  const lower = raw.toLowerCase();
  return /^[a-z]{2}$/.test(lower) ? `https://flagcdn.com/${lower}.svg` : null;
}

// Resolve a flag for a country row, preferring its ISO code then its code.
export function flagSrcForCountry(row) {
  return flagSrcForCode(row?.isoCode || row?.code);
}
